<template>
  <div>
    <LoadingState v-if="loading" :size="50" />
    <ConsoleOutput v-else :content="content" :ansi="true" />
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import ConsoleOutput from "@/components/smart/ConsoleOutput";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "CloudServerLog",
  props: {
    server: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConsoleOutput,
    LoadingState,
  },
  setup(props, { root }) {
    const loading = ref(true);
    const content = computed(() => store.state.cloudServers.serverLog);
    store
      .dispatch("cloudServers/getConsoleLog", props.server.id)
      .then(() => {
        loading.value = false;
      })
      .catch(() => {
        store.dispatch("toasts/addToast", {
          variant: "error",
          message: root.$t("toasts.console-log-error-message", {
            name: props.server.host,
          }),
          timeout: true,
        });
      });

    return {
      content,
      loading,
    };
  },
};
</script>
